import { Button, Tooltip } from '@cian/ui-kit';
import { IconFunctionalCalendar16 } from '@cian/ui-kit-design-tokens/icons';
import cx from 'clsx';
import * as React from 'react';

import * as styles from './FlatViewButtonCollapsed.css';
import { TFlatViewButtonComponent } from '../../types';

export const FlatViewButtonCollapsed: TFlatViewButtonComponent = ({ onClick, disabled }) => {
  return (
    <Tooltip title="Записаться на просмотр">
      <div className={cx(styles['button'], disabled && styles['button__disabled'])}>
        <Button
          onClick={onClick}
          disabled={disabled}
          beforeIcon={<IconFunctionalCalendar16 color="current_color" />}
          theme="fill_secondary"
          size="M"
        />
      </div>
    </Tooltip>
  );
};
